import BlankLayout from "../components/BlankLayout";
import BareLayout from "../components/BareLayout";
import { routes } from "./routes";

const finalRoutes = routes.map((route) => ({
  ...route,
  element:
    route.layout === "blank" ? (
      <BareLayout>{route.element}</BareLayout>
    ) : (
      <BlankLayout>{route.element}</BlankLayout>
    ),
}));

const router = finalRoutes;

export default router;
